export default __webpack_public_path__ + "static/media/hexagon-on.f5e37d47.svg";